<div class="coupon-info-wrapper">
 <i class="material-icons">card_giftcard</i>
 <span class="coupon-msg">
  {{couponMsg}}*
 </span>
 <div class="info-wrapper">
   <i class="material-icons">info</i>
   <ng-container *ngTemplateOutlet="popover"></ng-container>
  </div>
</div>
<ng-template #popover>
  <div class="popover-content">
      <span>Your contribution matters! Help bring this fundraiser closer to its goal.</span>
    </div>
</ng-template>
